"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateTeamsAppArguments = exports.ValidateTeamsAppOptions = void 0;
exports.ValidateTeamsAppOptions = [
    {
        name: "manifest-file",
        questionName: "manifest-path",
        type: "string",
        shortName: "t",
        description: "Specifies the app manifest file path.",
        default: "./appPackage/manifest.json",
    },
    {
        name: "app-package-file",
        questionName: "app-package-file-path",
        type: "string",
        shortName: "p",
        description: "Specifies the zipped app package path, it's a relative path to project root folder, defaults to '${folder}/appPackage/build/appPackage.${env}.zip'",
    },
];
exports.ValidateTeamsAppArguments = [];
//# sourceMappingURL=ValidateTeamsAppOptions.js.map